module.exports = __webpack_public_path__ + "img/20200729135846.f98a6629.png";